import React from 'react';
import styled, { StyledComponentClass } from 'styled-components';
import c from 'classnames';

import { Size } from '../../types';
import { colors, sizes } from '../../styles';

export interface Props {
  className?: string;
  children: any;
  padding?: Size;
  margin?: Size;
  stackedMargin?: Size;
  style?: any;
}

class Panel extends React.Component<Props, any> {
  public static defaultProps: Props = {
    children: null,
    margin: 'md',
    padding: 'md',
  };

  public render() {
    const {
      children,
      className,
      padding,
      margin,
      stackedMargin,
      style,
    } = this.props;

    return (
      <div
        children={children}
        className={c(
          className,
          margin && `margin-${margin}`,
          padding && `padding-${padding}`,
          stackedMargin && `stacked-${stackedMargin}`,
        )}
        style={style}
      />
    );
  }
}

const panelSizes = ['xs', 'sm', 'md', 'lg', 'xl'].reduce(
  (rule, size) =>
    rule +
    `
      &.margin-${size} {
        margin: ${sizes.block[size]};
      }
      &.padding-${size} {
        padding: ${sizes.block[size]};
      }
      &.stacked-${size} {
        margin: ${sizes.block[size]} 0; /* overrides .margin-* */
      }
    `,
  '',
);

export default styled(Panel)`
  background: white;
  border-radius: 6px;
  box-shadow: 0 0 0 1px ${colors.grey100};
  position: relative;

  ${panelSizes};
`;
